'use client';

import IconButton from '@enlighten/design-system/dist/IconButton';
import Image from 'next/image';

import MetaImage from '@/assets/images/img_meta.png';
import KakaoLogo from '@/assets/images/sns/kakao.png';
import type { WordpressLang } from '@/components/wordpress/utils/constants';

const TEXT: Record<WordpressLang, string> = {
	ko: '웹으로 보기',
	en: 'View on web',
};

type KakaoTemplate = typeof Kakao.Share.sendDefault extends (settings: infer Settings) => any ? Settings : {};

interface KakaoSharedIconButtonProps {
	title: string;
	url: string;
	lang: WordpressLang;
	imageUrl?: string;
}

const KakaoSharedIconButton = ({ title, url, lang, imageUrl }: KakaoSharedIconButtonProps) => {
	const template: KakaoTemplate = {
		objectType: 'feed',
		content: {
			title,
			imageUrl: imageUrl || MetaImage.src,
			link: {
				mobileWebUrl: url,
				webUrl: url,
			},
		},
		buttons: [
			{
				title: TEXT[lang],
				link: {
					mobileWebUrl: url,
					webUrl: url,
				},
			},
		],
	};

	return (
		<IconButton
			title="kakao"
			onClick={() => {
				Kakao.Share.sendDefault(template);
			}}
		>
			<Image src={KakaoLogo} alt="kakao logo" width={40} />
		</IconButton>
	);
};

export default KakaoSharedIconButton;
